module.exports = __webpack_public_path__ + "img/Avatar-41.c7d51f7d.svg";